class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.closingTimeout;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.openHandler = this.open.bind(this);
    this.closeWithClosingClassHandler = this.closeWithClosingClass.bind(this);
    
    if(!this.dataset.ignoreHover) {
      this.isAbleToUseMouse = matchMedia('(hover: hover)').matches;

      this.debouncedOnChange = debounce((event) => {
        this.isAbleToUseMouse = matchMedia('(hover: hover)').matches;
        this.initHoverDetails();
      }, 300);
  
      window.addEventListener('resize', this.debouncedOnChange.bind(this));
  
      this.initHoverDetails();
    }
    
    this.initClickSummary();
  }

  // initHoverDetails () {
  //   if(this.isAbleToUseMouse) {
  //     Shopify.addListener(this.mainDetailsToggle, 'mouseenter', this.openHandler);
  //     Shopify.addListener(this.mainDetailsToggle, 'mouseleave', this.closeWithClosingClassHandler);
  //   } else {
  //     this.mainDetailsToggle.removeEventListener('mouseenter', this.openHandler);
  //     this.mainDetailsToggle.removeEventListener('mouseleave', this.closeWithClosingClassHandler);
  //   }
  // }
initHoverDetails() {
  // Ensure previous listeners are removed
  this.mainDetailsToggle.removeEventListener('mouseenter', this._boundMouseEnter);
  this.mainDetailsToggle.removeEventListener('mouseleave', this._boundMouseLeave);

  if (this.isAbleToUseMouse) {
    this._boundMouseEnter = this.onMouseEnter.bind(this);
    this._boundMouseLeave = this.onMouseLeave.bind(this);

    this.mainDetailsToggle.addEventListener('mouseenter', this._boundMouseEnter);
    this.mainDetailsToggle.addEventListener('mouseleave', this._boundMouseLeave);
  }
}

onMouseEnter() {
  // Close only sibling disclosures at the same menu/list level.
  // The old implementation closed every <details> element on the page, which
  // could close a parent mega menu (or unrelated FAQ/cart disclosure) while
  // moving through nested header navigation.
  const item = this.parentElement;
  const siblingContainer = item ? item.parentElement : null;

  if (siblingContainer) {
    Array.from(siblingContainer.children).forEach((siblingItem) => {
      if (siblingItem === item) return;
      const siblingMenu = Array.from(siblingItem.children).find((child) => child.tagName === 'HEADER-MENU' || child.tagName === 'DETAILS-DISCLOSURE');
      if (!siblingMenu) return;
      const openDetail = siblingMenu.querySelector(':scope > details[open]');
      if (!openDetail) return;
      openDetail.removeAttribute('open');
      const summary = openDetail.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  this.open();
}

onMouseLeave() {
  // Optional: add slight delay to prevent flicker
  clearTimeout(this.hoverTimeout);
  this.hoverTimeout = setTimeout(() => {
    this.closeWithClosingClass();
  }, 100); // 100ms delay
}

  initClickSummary() {
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
      e.preventDefault();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.closeWithClosingClass();
      } else {
        this.open();
      }
    });
  }

  closeWithClosingClass() {
    if(this.classList.contains('ignore-close')) return;
    this.mainDetailsToggle.classList.add('closing');
    if(this.closingTimeout) {
      clearTimeout(this.closingTimeout);
    }
    this.closingTimeout = setTimeout(() => {
      this.close();
      this.mainDetailsToggle.classList.remove('closing');
    }, 300);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.closeWithClosingClass();
    this.mainDetailsToggle.querySelector('summary').focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.closeWithClosingClass();
    })
  }

  playAnimation() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.playAnimation();
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

let hoverSupport = matchMedia('(hover: hover)').matches;
window.addEventListener('resize', () => {
  hoverSupport = matchMedia('(hover: hover)').matches;
});

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header');
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.querySelectorAll(':scope > details > .header__menu-item--link').forEach(element => element.addEventListener('click', this.onClickSummary));
  }

  onClickSummary(event) {
    if(hoverSupport) {
      event.preventDefault();
      window.location = event.currentTarget.dataset.href;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
